<!--
 * @Description: 平台账号管理
-->
<template>
  <div class="platform-admin-list">
    <div class="platform-admin-toolbar">
      <el-button type="primary" @click="handleFilterButton('添加账号')">
        添加账号
      </el-button>
    </div>
    <Table
      :list-query-params.sync="listQueryParams"
      v-bind="tableAttrs"
      v-on="tableEvent"
    />
    <el-dialog
      :title="title"
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      width="520px"
      top="8vh"
    >
      <Detail
        ref="getTable"
        :title="title"
        styleType="dialog"
        :tableData="dialogForm"
        :tableFormAttrs="dialogFormAttrs"
        formLabelWidth="91px"
      >
      </Detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm()">添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from "@/components/Table/index.vue";
import Detail from "@/components/Detail/index.vue";
import md5 from "js-md5";
import Cookies from "js-cookie";
import { PASSWORD_PLACEHOLDER } from "@/utils/validate";
import {
  platformAdminList,
  platformAdminCreate,
  platformAdminStatus,
} from "@/api/bill";

export default {
  name: "platformAdmin",
  components: {
    Table,
    Detail,
  },
  beforeRouteEnter(to, from, next) {
    const userType = +Cookies.get("type");
    const platformRole = Cookies.get("storeId");
    if (userType === 1 && platformRole === "1") {
      next();
    } else {
      next("/404");
    }
  },
  data() {
    return {
      title: "添加账号",
      listQueryParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      tableConfig: [
        {
          label: "名称",
          minWidth: "120",
          autoWidth: true,
          value: "name",
        },
        {
          label: "手机号",
          minWidth: "130",
          autoWidth: true,
          value: "phone",
        },
        {
          label: "角色",
          minWidth: "110",
          autoWidth: true,
          value: "role",
        },
        {
          label: "状态",
          minWidth: "90",
          autoWidth: true,
          value: "statusText",
        },
        {
          label: "创建时间",
          minWidth: "180",
          autoWidth: true,
          value: "create_time",
        },
      ],
      dialogFormAttrs: [
        {
          title: "名称:",
          placeholder: "请输入名称",
          type: "input",
          value: "name",
          required: true,
        },
        {
          title: "手机号:",
          placeholder: "请输入手机号",
          type: "input",
          value: "phone",
          required: true,
        },
        {
          title: "角色:",
          placeholder: "请选择角色",
          type: "select",
          value: "role",
          required: true,
          options: [
            { label: "财务管理员", value: "2" },
            { label: "运营管理员", value: "3" },
          ],
        },
        {
          title: "初始密码:",
          placeholder: PASSWORD_PLACEHOLDER,
          type: "input",
          inputType: "text",
          value: "passwd",
          isClosePwd: true,
          required: true,
        },
      ],
      dialogFormVisible: false,
      dialogForm: {},
      loadingStatus: false,
    };
  },
  computed: {
    tableAttrs() {
      return {
        config: this.tableConfig,
        tableData: this.tableData,
        loadingStatus: this.loadingStatus,
        buttonsName: [{ label: "停用" }],
        isHasButtons: true,
        isShowNumber: true,
        isShowPagination: false,
        optionColumnWidth: 100,
      };
    },
    tableEvent() {
      return {
        subOpitonButton: this.handleTableOption,
      };
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      try {
        this.loadingStatus = true;
        const { data } = await platformAdminList();
        const list = Array.isArray(data) ? data : [];
        this.tableData = list.map((item) => {
          const isSuperAdmin = String(item.mappId) === "1";
          const enabled = Number(item.status) === 0;
          return {
            ...item,
            statusText: enabled ? "启用" : "停用",
            actionButtons: isSuperAdmin
              ? []
              : [{ label: enabled ? "停用" : "启用" }],
          };
        });
        this.listQueryParams.total = this.tableData.length;
      } catch (error) {
        console.log(error);
        this.tableData = [];
      } finally {
        this.loadingStatus = false;
      }
    },
    handleFilterButton(val) {
      if (val === "添加账号") {
        this.dialogForm = {
          name: "",
          phone: "",
          role: "2",
          passwd: "",
        };
        this.dialogFormVisible = true;
      }
    },
    submitForm() {
      this.$refs.getTable.getTableRef().validate((valid) => {
        if (!valid) return;
        const params = {
          name: (this.dialogForm.name || "").trim(),
          phone: (this.dialogForm.phone || "").trim(),
          role: this.dialogForm.role,
          passwd: md5(md5(this.dialogForm.passwd)),
        };
        platformAdminCreate(params).then(() => {
          this.dialogFormVisible = false;
          this.getList();
          this.$message.success("添加成功");
        });
      });
    },
    handleTableOption(index, row, option) {
      if (!row || !option) return;
      const enable = option.label === "启用";
      const actionText = enable ? "启用" : "停用";
      this.$confirm(`确认${actionText}该账号吗?`, "", {
        type: "warning",
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then(async () => {
          await platformAdminStatus({
            phone: row.phone,
            status: enable ? 0 : 1,
          });
          this.getList();
          this.$message.success(`${actionText}成功`);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.platform-admin-list {
  .platform-admin-toolbar {
    background: #fff;
    padding: 16px 20px 0;
  }
  .el-dialog__wrapper {
    display: inherit;
  }
}
</style>
